import { AUTH_STATUSES } from '@wheely/web-auth-lib/core';
import { useAuth as useLegacyAuth } from '@wheely/web-auth-lib/legacy';
import { useAuth as useV3Auth } from '@wheely/web-auth-lib/react';

import { AUTH_MODES, getAuthMode } from '../mode';

/**
 * Auth state the app renders by, taken from the stack that owns the current
 * visit. Needs both providers above it (see create-onboarding-wizard).
 */
export const useAppAuth = (): { isAuthenticated: boolean } => {
  const legacy = useLegacyAuth();
  const v3 = useV3Auth();

  return {
    isAuthenticated:
      getAuthMode() === AUTH_MODES.LEGACY
        ? legacy.isAuthenticated
        : v3.status === AUTH_STATUSES.AUTHENTICATED,
  };
};
